import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowRight, ChevronLeft } from 'lucide-react';

export const DetailBreadcrumb = ({ kind, basePath, label }) => (
  <section className="pt-[120px] pb-8 px-6 lg:px-10 border-b border-white/5">
    <div className="max-w-[1300px] mx-auto flex items-center justify-between gap-4">
      <Link data-testid={`${kind}-back-to-list-link`} to={basePath} className="inline-flex items-center gap-2 text-[14px] text-white/70 hover:text-accent transition group">
        <ChevronLeft size={16} className="group-hover:-translate-x-1 transition-transform" />
        <span className="border-b border-white/30 group-hover:border-accent/60 pb-1">{label}</span>
      </Link>
      <Link data-testid={`${kind}-home-link`} to="/" className="text-[14px] text-white/70 hover:text-accent transition border-b border-white/30 hover:border-accent/60 pb-1">Ana Sayfa</Link>
    </div>
  </section>
);

const AdjacentLink = ({ item, direction, kind, basePath, label }) => {
  const isNext = direction === 'next';
  const Icon = isNext ? ArrowRight : ArrowLeft;
  return (
    <Link data-testid={`${kind}-${direction}-link`} to={`${basePath}/${item.slug}`} className={`group flex items-center gap-5 p-5 rounded-2xl bg-card border border-border hover:border-primary/50 transition-colors duration-500 ${isNext ? 'sm:flex-row-reverse sm:text-right' : ''}`}>
      <span className="w-12 h-12 rounded-full border border-border group-hover:bg-primary group-hover:border-primary flex items-center justify-center text-white shrink-0 transition-colors duration-300"><Icon size={18} /></span>
      <div className="min-w-0">
        <div className="text-[10.5px] tracking-[0.24em] text-accent font-medium uppercase">{isNext ? 'Sonraki' : 'Onceki'} {label}</div>
        <div className="text-[15px] text-white font-semibold truncate mt-1.5">{item.title}</div>
      </div>
    </Link>
  );
};

export const DetailNavigation = ({ previous, next, kind, basePath, label }) => (
  <section className={`px-6 lg:px-10 ${kind === 'project' ? 'pb-20' : 'py-16'}`}>
    <div className="max-w-[1300px] mx-auto grid sm:grid-cols-2 gap-5">
      <AdjacentLink item={previous} direction="previous" {...{ kind, basePath, label }} />
      <AdjacentLink item={next} direction="next" {...{ kind, basePath, label }} />
    </div>
  </section>
);